export default "__VITE_ASSET__BqMM6vo2__"